import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";
import {AgentType} from "../../types/agent.type";

export class agentsMultiSelectCtrl implements IController {

  selectedIds: any;
  accountIds: any[];
  branchIds?: any[];
  tags?: any[];
  agentTypes?: AgentType[];
  ngPlaceholder: any;
  isDisabled: any;
  onChange: Function;

  private agentsRef: any;
  public selectedAgents: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $agents: $agentsFactory, private $element, private $filter) {
    this.agentsRef = this.$agents();
  }

  $onInit() {
    this._setSelectedAgents();
  };

  $onChanges(changes) {
    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this._setSelectedAgents();
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedAgents();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const branchIdsRef = this.branchIds;
    const tagsRef = this.tags;
    const carrierIdsRef = this.accountIds;
    const agentTypes = this.agentTypes;
    const ngPlaceholderRef = this.ngPlaceholder;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'agents';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.branchIdsRef = branchIdsRef;
        this.queryMapRef = {
          branchIds: branchIdsRef,
          tags: tagsRef,
          carrierIds: carrierIdsRef,
          agentTypes: agentTypes
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({ids: selectedIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: []});
  }

  private _setSelectedAgents() {
    if (!!this.selectedIds) {
      this.agentsRef.$asyncValues(this.selectedIds)
        .then((agents) => {
          this.selectedAgents = _.orderBy(agents, ['user.firstName'], ['asc']);
          this._setSelectedText();
        });
    } else {
      this.selectedAgents = [];
      this._setSelectedText();
    }
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedAgents, (a, i) => {
      string += this.$filter('userName')(a.user);
      if ((i + 1) < this.selectedAgents.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.$filter('userName')(this.selectedAgents[0].user) + ` +${this.selectedAgents.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentsMultiSelect', {
    bindings: {
      selectedIds: '<?',
      accountIds: '<?',
      branchIds: '<?',
      tags: '<?',
      agentTypes: '<?',
      // options: '<?',
      // optionIds: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./agents-multi-select.html').default,
    controller: agentsMultiSelectCtrl
  });
